import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import '../../CSS/entrepreneur.css';
import { FaArrowRight, FaArrowLeft, FaArrowRight as FaArrowRightIcon } from "react-icons/fa";
import Action from "../composant_reutilisable/action";
import { useLanguageData } from '../../hooks/useLanguageData';
import SafeHTML from "../SafeHTML";

const Programme = () => {
    const { t } = useTranslation();
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [programsList, setProgramsList] = useState([]);
    const [currentProgram, setCurrentProgram] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [images, setImages] = useState([]);

    const { 
        data: carouselResponse, 
        loading: carouselLoading 
    } = useLanguageData('/api/v1/embassy/static-data?slug=carousel');

    const { 
        data: pagResponse, 
        loading: pagLoading, 
        error: pagError 
    } = useLanguageData('/api/v1/embassy/useful-links-category?slugCategory=lien_pag');

    useEffect(() => {
        if (carouselResponse?.data && carouselResponse.data.length > 0) {
            const carouselItem = carouselResponse.data[0];
            if (carouselItem.album && carouselItem.album.length > 0) {
                setImages(carouselItem.album);
            }
        }
    }, [carouselResponse]);

    useEffect(() => {
        if (pagResponse?.data && Array.isArray(pagResponse.data)) {
            let activePrograms = pagResponse.data.filter(item => item.state === true);
            
            // Trier par date de création (du plus ancien au plus récent)
            activePrograms.sort((a, b) => {
                const dateA = new Date(a.creationDate.date);
                const dateB = new Date(b.creationDate.date);
                return dateA - dateB; // Ordre croissant (ancien → récent)
            });
            
            console.log('📊 PAG list triée (ancien → récent):', activePrograms);
            setProgramsList(activePrograms);
            
            // Par défaut, afficher le plus récent (dernier de la liste)
            if (activePrograms.length > 0) {
                setCurrentProgram(activePrograms[activePrograms.length - 1]);
                setCurrentIndex(activePrograms.length - 1);
            }
        }
    }, [pagResponse]);

    // Navigation vers le PAG précédent (plus ancien)
    const prevProgram = () => {
        if (programsList.length === 0) return;
        
        const newIndex = currentIndex - 1;
        if (newIndex >= 0) {
            setCurrentIndex(newIndex);
            setCurrentProgram(programsList[newIndex]);
        }
    };

    // Navigation vers le PAG suivant (plus récent)
    const nextProgram = () => {
        if (programsList.length === 0) return;
        
        const newIndex = currentIndex + 1;
        if (newIndex < programsList.length) {
            setCurrentIndex(newIndex);
            setCurrentProgram(programsList[newIndex]);
        }
    };

    useEffect(() => {
        if (images.length === 0) return;
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => 
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 2000);
        return () => clearInterval(interval);
    }, [images.length]);

    const loading = carouselLoading || pagLoading;

    const InfoIndisponible = () => (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            color: '#999',
            fontStyle: 'italic',
            fontSize: '1rem',
            textAlign: 'center',
            padding: '2rem',
            margin: '1rem 0'
        }}>
            {t('common.infoUnavailable')}
        </div>
    );

    if (loading) {
        return (
            <div className="visiter-container">
                <div className="visiter-content">
                    <div className="loading-container">
                        <div className="loading-spinner mt-2"></div>
                        <p>{t('common.loading')}</p>
                    </div>
                </div>
            </div>
        );
    }

    // Styles inline pour les boutons de navigation
    const navContainerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        // marginTop: '2rem',
        padding: '1rem 0',
        borderTop: '1px solid #e0e0e0',
        width: '100%'
    };

    const buttonStyle = {
        background: '#1a3c5e',
        border: 'none',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        fontSize: '16px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        lineHeight: 'normal'
    };

    const buttonDisabledStyle = {
        ...buttonStyle,
        background: '#5e5e5e',
        cursor: 'not-allowed',
        opacity: 0.5
    };

    const iconStyle = {
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center'
    };

    return (
        <div className="visiter-container mt-4">
            <div className="visiter-content">
                <div className="visiter-texte">
                    <div className="visiter-paragraphe">            
                        {currentProgram ? (
                            <>
                                <div className="dynamic-content-scroll" id="content-special">
                                    <SafeHTML html={currentProgram.description} />
                                </div>
                                
                                {currentProgram.linkAccess && currentProgram.textBouton && (
                                    <a className="btn-invest" href={currentProgram.linkAccess} target="_blank" rel="noopener noreferrer">
                                        {currentProgram.textBouton}
                                        <FaArrowRight className="btn-icon" />
                                    </a>
                                )}
                            </>
                        ) : (
                            <InfoIndisponible />
                        )}

                        {programsList.length > 1 && (
                            <div style={navContainerStyle}>
                                <button 
                                    onClick={prevProgram} 
                                    disabled={currentIndex === 0}
                                    style={currentIndex === 0 ? buttonDisabledStyle : buttonStyle}
                                >
                                    <span style={iconStyle}>
                                        <FaArrowLeft />
                                    </span>
                                    <span>Précédent</span>
                                </button>
                                
                                <button 
                                    onClick={nextProgram} 
                                    disabled={currentIndex === programsList.length - 1}
                                    style={currentIndex === programsList.length - 1 ? buttonDisabledStyle : buttonStyle}
                                >
                                    <span>Suivant</span>
                                    <span style={iconStyle}>
                                        <FaArrowRightIcon />
                                    </span>
                                </button>
                            </div>
                        )}
                    </div>
                    
                    <div className="image-carousel">
                        {images.length > 0 ? (
                            <img
                                src={images[currentImageIndex]}
                                alt=""
                                style={{
                                    width: '800px',
                                    height: 'auto',
                                    maxHeight: 'auto',
                                    objectFit: 'cover'
                                }}
                            />
                        ) : (
                            <InfoIndisponible />
                        )}
                    </div>
                </div>

                <Action />
            </div>

            <style>
                {`
                    .loading-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 2rem;
                        text-align: center;
                        min-height: 200px;
                    }

                    .loading-spinner {
                        width: 40px;
                        height: 40px;
                        border: 4px solid #f3f3f3;
                        border-top: 4px solid #1a3c5e;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                        margin-bottom: 1rem;
                    }

                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
};

export default Programme;